import Vue from 'vue'
import Vuex from 'vuex'
import * as d3 from 'd3'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    forestData: [],
    submissionsData: [],
    currentGroup: {},
    currentWishes: [{story: null, name: null, picture: null}]
  },
  getters: {
  },
  mutations: {
    updateData(state, data) {
        state.forestData = data[0];
        state.submissionsData = data[1];

        let groups = d3.group(state.submissionsData, d => d.group);

        state.forestData.forEach(d => {
          //check if group exists, else set count to 0 and names array to []
          let count = (groups.get(d.group) != undefined) ? groups.get(d.group).length : 0;
          let names = (groups.get(d.group) != undefined) ? groups.get(d.group).map(d => d.name) : [];

          d.submissions = count;
          if (d.submissions == 0) {
            d.treeType = "newtree";
            d.treeIcon = new URL("../assets/img/map/tree_sapling.png", import.meta.url).href;                 
          } else if (d.submissions / parseInt(d.headcount) < 0.3) {
            d.treeType = "sapling";
            d.treeIcon = new URL("../assets/img/map/tree_sapling.png", import.meta.url).href;
          } else if (d.submissions / parseInt(d.headcount) < 0.7) {
            d.treeType = "youngadult";
            d.treeIcon = new URL("../assets/img/map/tree_young_adult.png", import.meta.url).href;
          } else {
            d.treeType = "mature";
            d.treeIcon = new URL("../assets/img/map/tree_mature.png", import.meta.url).href;
          }

          d.textLength = d.trunk.length;
          d.submittedNames = names;
        })
        
        // Break story into paragraphs
        state.submissionsData.forEach(d => {
          let paragraphs = d.story.split("\n");
          d.paragraphs = paragraphs.filter(d => d != "");
        })

        //console.log(state);
    },
    updateGroup(state, data) {
      state.currentGroup = data;
    },
    updateWishes(state, data) {
      state.currentWishes = data;
      //console.log(state.currentWishes);
    }
  },
  actions: {
    loadData({ commit }) {
      let groupsCSV = "data/groups.csv";
      let submissionsCSV = "data/submissions.csv";

      Promise.all([d3.csv(groupsCSV), d3.csv(submissionsCSV, (d, i, names) => {
        // console.log(d, i, names)
        // 0-4 "ID", "Start time", "Completion time", "Email", "name", 
        // 5-6 "Please enter your Department/Team", "If you answered ... draw that connection.",
        // 7-10 "picture", "By submitting this ... not limited", "story", "group"
        let pictures = d[names[7]].split('; ')
        pictures = pictures.filter((item) => {
          const matched = item.match(/\.(jpg|jpeg|png|gif)$/i)
          if (!matched) {
            console.log(d[names[4]], item)
          }
          return matched
        })
        const row = {
          id: d.ID,
          group: d[names[10]],
          name: d[names[4]],
          picture: pictures.length > 0 ? pictures[0] : '',
          story: d[names[9]]
        }
        // console.log(row)
        return row
      })]).then(data => {
        commit("updateData", data)
      })
    },
  }
})
